export const getLeadStateByPractitioner = (practitioner: any) => {
    if (practitioner?.data_source === "PRACTITIONER_ACCOUNT_VIEW") {
        if (practitioner?.stage === "PROSPECT" || practitioner?.stage === "CUSTOMER") {
            return "";
        }
        if (!practitioner?.stage || practitioner?.stage === "LEAD") {
            if (practitioner.status === "LEAD-INCOMPLETE") {
                return "Not in Netsuite: Incomplete Lead"
            }
            if (practitioner.status === "LEAD-READY2SUBMIT") {
                return "Not in Netsuite: Ready to Submit"
            }
            if (practitioner.status === "LEAD-AWAITING-NETSUITE") {
                return "Submitted to Netsuite: Awaiting Qualification Process."
            }
            return "Not in Netsuite: Unknown status";
        }
    }
    if (practitioner?.data_source === "PRACTITIONER_DISTRIBUTOR_ACCOUNT_VIEW") {
        return "";
    }
    if (practitioner?.data_source === "PRACTITIONER_ACCOUNT_VIEW_NM") {
        return "Not in Netsuite: Imported from Badger";
    }
    if (practitioner?.data_source === "SALES ASSISTANT") {
        if (!practitioner?.stage || practitioner?.stage === "LEAD") {
            if (practitioner.status === "LEAD-INCOMPLETE") {
                return "Not in Netsuite: Incomplete Lead"
            }
            if (practitioner.status === "LEAD-READY2SUBMIT") {
                return "Not in Netsuite: Ready to Submit"
            }
            if (practitioner.status === "LEAD-AWAITING-NETSUITE") {
                return "Submitted to Netsuite: Awaiting Qualification Process."
            }
        }
        if (practitioner?.netsuite_id) {
            return "";
        }        
        if (practitioner?.stage === "PROSPECT" || practitioner?.stage === "CUSTOMER") {
            return "";
        }
        
        return "Not in Netsuite: Unknown status";
    }

    return "Not in Netsuite: Missing Data Source Value";
}